export const aiTestimonials = [
  {
    image      :'/testimonials/daniel-defreitas.webp',
    name       :'Daniel De Freitas',
    role       :'Co-founder',
    company    :'Character.AI',
    testimonial:'We were impressed with the efficiency of Pareto\'s team in helping us collect high-quality and challenging datasets on a tight schedule, using cost-effective and flexible processes. Their streamlined recruitment, training, and communication with the rater pool allowed us to adjust usage as needed. Their impressive versatility and ease of use throughout the process made it a pleasure to work with them.',
    rating     :5,
  },
  {
    image      :'/testimonials/romal-thoppilan.webp',
    name       :'Romal Thoppilan',
    role       :'Founding Researcher',
    company    :'Character.AI',
    testimonial:'The greatest unlock for human data collection has been using Pareto to run non-conventional or experimental projects. Their on-demand experts are a game changer for getting quality data across a broad scope of tasks with minimal commit and transparent costs.',
    rating     :5,
  },
  {
    image      :'/testimonials/prajit-ramachandran.webp',
    name       :'Prajit Ramachandran',
    role       :'Founding Researcher',
    company    :'Character.AI',
    testimonial:'We had a novel task that we needed to complete on a short time scale. The Pareto team worked very closely with us to onboard, disambiguate, and scale up for fast task completion. We\'re continuing to work with the same pool of high quality raters for our newer tasks.',
    rating     :5,
  },
  {
    image      :'/testimonials/mark-whiting.webp',
    name       :'Mark Whiting',
    role       :'Senior Scientist',
    company    :'UPenn',
    testimonial:'Crowdsourcing platforms historically prioritize requesters, leading to a fragmented worker pool with constant struggles around pricing, quality and reputation. Bucking this trend, Pareto boosts worker agency and engagement — a more efficient marketplace that leaves workers and requesters better off.',
    rating     :5,
  },
  {
    image      :'/testimonials/curtis-chin.webp',
    name       :'Curtis Chin',
    role       :'I/ML Program Manager',
    company    :'Bytedance',
    testimonial:'Pareto is outstanding and working with them has been a pleasure. Their team\'s expertise in data collection and task setup guidance were instrumental in ensuring success. They have a flair for matching top-notch expert talent in line with work requirements (which they pick up well thanks to their deep knowledge of the space). The quality of their work is exceptional and their timeliness impeccable, and I highly recommend them.',
    rating     :5,
  },
  {
    image      :'/testimonials/teddy-rothschild.webp',
    name       :'Teddy Rothschild',
    role       :'Program Manager',
    company    :'Amazon',
    testimonial:'I mean this in the nicest way possible but I don\'t think about Pareto all that much. I have full trust in everything they\'re doing, which for me is pretty good feedback.',
    rating     :5,
  },
]

export const userTestimonials = [
  {
    image      :'/testimonials/kyle-giffin.webp',
    name       :'Kyle Giffin',
    role       :'Co-founder and COO',
    company    :'LatchBio',
    testimonial:'Fast, professional, and efficient. The Pareto team does lead generation better than anyone else and their customer service is exceptional. I would recommend Pareto to any founder.',
    rating     :5,
    labels     :['Bioinformatics'],
  },
  {
    image      :'/testimonials/prasad-kawthekar.webp',
    name       :'Prasad Kawthekar',
    role       :'Co-founder and CEO',
    company    :'Dashwords.ai',
    testimonial:'We have been working with the Pareto Team since 2020 and it has been a smooth ride ever since. They have been able to efficiently gather variety of data and complete critical tasks on time. They are the perfect complement to our team, urgent tasks or not.',
    rating     :5,
    labels     :['AI', 'SaaS'],
  },
  {
    image      :'/testimonials/chris-olmanson.webp',
    name       :'Chris Olmanson',
    role       :'Co-founder',
    company    :'Beaming',
    testimonial:'The Pareto team has been amazing. Their attention to detail, hustle, and communication are all 10/10 and I\'m looking forward to partnering on many more projects! It\'s been a pleasure to work with Pareto. A big part of our strategy has been getting this directory up so it\'s awesome to be able to work with Pareto to get it up and running. Our investors are always so impressed by how many states we have covered.',
    rating     :5,
    labels     :['Healthcare'],
  },
  {
    image      :'/testimonials/atob.webp',
    name       :'Monique Tuin',
    role       :'Business Operations',
    company    :'AtoB',
    testimonial:'The Pareto team has been a great asset to support our underwriting and risk analysis team. All team members learn new tasks quickly, have an impressive attention to detail, and inspire confidence in their work on a daily basis.',
    rating     :5,
    labels     :['Fintech', 'SaaS'],
  },
  {
    image      :'/testimonials/lilian-cartwright.webp',
    name       :'Lilian Cartwright',
    role       :'Co-founder and CEO',
    company    :'ShelfLife',
    testimonial:'ShelfLife would not exist as it does today without the help of Pareto. Working with Pareto for our data heavy tasks was on of the best decisions I made as a founder. Pareto moves quickly and efficiently to deliver exactly what we need, when we need it.',
    rating     :5,
  },
  {
    image      :'/testimonials/nicole-kobilansky.webp',
    name       :'Nicole Kobilansky',
    role       :'Co-founder and CEO',
    company    :'Storey App',
    testimonial:'Working with Pareto has really freed up a lot of our time while building an early stage startup - they are detail oriented and super responsive, I can\'t recommend them enough!',
    rating     :5,
    labels     :['E-commerce', 'Fashion'],
  },
  {
    image      :'/testimonials/harris-stolzenberg.webp',
    name       :'Harris Stolzenberg',
    role       :'Co-founder and CEO',
    company    :'Flok',
    testimonial:'Pareto saved Flok hundreds of hours by gathering and structuring data for our hotel database. The team followed our directions well, and when edge cases inevitably popped up, they handled them to our satisfaction. We were very impressed by the quality of service, level of communication, and promptness in getting our task completed.',
    rating     :5,
    labels     :['Booking', 'Travel'],
  },
  {
    image      :'/testimonials/carlos-del-carpio.webp',
    name       :'Carlos Del Carpio',
    role       :'Co-founder and CEO',
    company    :'Valia Pro',
    testimonial:'Pareto has become an extension of our team. They are incredibly responsive and reliable, and they help us accomplish more work, in a faster and cheaper way every day. Once you start working with them, you won\'t stop. We totally recommend them!',
    rating     :5,
    labels     :['Real Estate', 'Networking'],
  },
  {
    image      :'/testimonials/baji-gobburi.webp',
    name       :'Baji Gobburi',
    role       :'Vice President, Sales',
    company    :'Aquacycle',
    testimonial:'We have been working with Pareto since November 2021 to help us in lead generation, CRM clean up and email campaigns. They have been extremely responsive and excellent at follow-through. Everyone on the team is quick to grasp the customer\'s needs, ask clarifying questions and execute the tasks efficiently. Highly recommend them to add value to your team.',
    rating     :5,
    labels     :['Biotech', 'Sustainability'],
  },
  {
    image      :'/testimonials/manshu-agarwal.webp',
    name       :'Manshu Agarwal',
    role       :'Managing Partner',
    company    :'Colbridge Ventures',
    testimonial:'I was amazed at the relevancy of the contacts that the Pareto team found and the speed at which they did so. A super cost effective way to get to your target customers, investors, or candidates without breaking the bank or your back.',
    rating     :5,
    labels     :['Fundraising', 'Sales'],
  },
  {
    image      :'/testimonials/ellis-driscoll.webp',
    name       :'Ellis Driscoll',
    role       :'Vice President, Operations',
    company    :'Laskie',
    testimonial:'We\'ve been rapidly iterating on the Laskie Platform for the past year and we often need extra help to move fast.The Pareto Team provides elastic, on-demand support which has helped us get through our busiest weeks. The Pareto Team is easy to work with. They\'re responsive, trustworthy, and have great attention to detail. Working with Pareto has save us hundreds of hours and countless headaches.',
    rating     :5,
  },
  {
    image      :'/testimonials/morgan-esecson.webp',
    name       :'Morgan Esecson',
    role       :'Senior Manager, Growth',
    company    :'Modern Fertility',
    testimonial:'When we started working with Pareto I was immediately impressed by how quickly the team was able to start executing based on our lead requirements and the quality of the leads they were sourcing for us. The Pareto team also does an incredible job of immediately implementing feedback and clearly communicating any questions or issues they are running into. At this point, we consider Pareto a part of our team!',
    rating     :5,
    labels     :['Fertility Tech', 'Health'],
  },
  {
    image      :'/testimonials/claire-coder.webp',
    name       :'Claire Coder',
    role       :'Founder and CEO',
    company    :'Aunt Flow',
    testimonial:'Pareto has been a reliable resource to help me get things DONE. Their response times, accuracy, and detail-focus work makes my job EASY - It is refreshing to have such a strong and consistent team that can do anything from calendar management to large data pulls!',
    rating     :5,
    labels     :['Health', 'Education'],
  },
  {
    image      :'/testimonials/trevor-mckendrick.webp',
    name       :'Trevor McKendrick',
    role       :'Founder and CEO',
    company    :'Seis',
    testimonial:'Pareto has been one of our best secret weapons to doing research, finding important contacts, and generally outsourcing manual & time consuming work. Their work is fast, high quality, and something I can always trust to be done well. Working with them is a no brainer.',
    rating     :5,
    labels     :['Finance', 'Fintech'],
  },
  {
    image      :'/testimonials/adrian-pollard.webp',
    name       :'Adrian Pollard',
    role       :'Co-founder',
    company    :'HollaEx',
    testimonial:'We gel with Pareto and it\'s helpful how we can distribute the work easily. The team has given a good response time, communicated in an effective and friendly manner, and been reliable and consistent!',
    rating     :5,
    labels     :['Crypto', 'Blockchain'],
  },
  {
    image      :'/testimonials/keone-hon.webp',
    name       :'Keone Hon',
    role       :'Co-founder and CEO',
    company    :'Monad Labs',
    testimonial:'Pareto has compiled several spreadsheets for our company. They are very precise and fast, they ask great clarifying questions, and they deal with corner cases with good common sense. Pricing is reasonable. The slack groups make it easy to discuss any clarifying questions in realtime. I plan to continue to use them for any tasks that I can.',
    rating     :5,
    labels     :['Blockchain'],
  },
  {
    image      :'/testimonials/blanchard-kenfack.webp',
    name       :'Blanchard Kenfack',
    role       :'Strategic Partnerships',
    company    :'LatchBio',
    testimonial:'The Pareto team is professional, quick, and comprehensive in their services. They never fail to deliver tasks on time and with the utmost quality.',
    rating     :5,
    labels     :['AI', 'Biotech'],
  },
  {
    image      :'/testimonials/eva-alderman.webp',
    name       :'Eva Alderman',
    role       :'Business Development',
    company    :'LatchBio',
    testimonial:'Pareto saves us so much time and energy. They are incredibly responsive as a team, and 100% adhere to deadlines. We often send them urgent tasks (sorry Pareto), and they\'ve always managed to get the job done. We\'re so glad that we have them as a resource. Thanks Amy + team!',
    rating     :5,
    labels     :['AI', 'Biotech'],
  },
  {
    image      :'/testimonials/dan-cleary.webp',
    name       :'Dan Cleary',
    role       :'Co-founder and CEO',
    company    :'Tether',
    testimonial:'The Pareto team is amazing! The Pareto team is fast, responsive and diligent. They took my requests and executed them perfectly.',
    rating     :5,
    labels     :['SaaS'],
  },
  {
    image      :'/testimonials/emily-watts.webp',
    name       :'Emily Watts',
    role       :'Business Operations',
    company    :'Sora ID',
    testimonial:'Pareto is quick to respond and delivered high quality work. They never missed a deadline and always followed up with questions if they had any.',
    rating     :5,
    labels     :['Cybersecurity'],
  },
  {
    image      :'/testimonials/nick-saxby.webp',
    name       :'Nick Saxby',
    role       :'Co-founder',
    company    :'Saxby',
    testimonial:'We genuinely love Pareto and the work they help us with! Our project partners have always been insanely responsive, clear on communication, and always deliver. 10/10 recommend them!',
    rating     :5,
    labels     :['Marketing', 'Design'],
  },
  {
    image      :'/testimonials/mckelvey-packard.webp',
    name       :'McKelvey Packard',
    role       :'Chief Operating Officer',
    company    :'Everkey',
    testimonial:'Pareto is great! They\'re able to quickly learn tasks and have freed up a lot of time for me. I give them the instructions, maybe correct one or two things after the first time they do it, and then they\'re off to the races and I never have to think about it again!',
    rating     :5,
    labels     :['Cybersecurity'],
  },
  {
    image      :'/testimonials/steven-macmaster.webp',
    name       :'Steven MacMaster',
    role       :'Growth',
    company    :'Circa',
    testimonial:'Pareto has been a phenomenal asset to our organization. I\'m continually impressed by how well they execute a great variety of projects with incredible consistency and transparency.',
    rating     :5,
    labels     :['Automation', 'Supply Chain'],
  },
  {
    image      :'/testimonials/pranitha-patil.webp',
    name       :'Pranitha Patil',
    role       :'Co-founder and COO',
    company    :'Function Health',
    testimonial:'Guaranteed quality, timeliness, and strong collaboration. Consistently high quality and easy to work with. Our team has collaborated with Pareto for about a year, and we wouldn\'t be able to scale our operations without their support. I highly recommend working with them for any projects related to data migration, data entry, QA, research, and more.',
    rating     :5,
    labels     :['Health'],
  },
  {
    image      :'/testimonials/matt-pru.webp',
    name       :'Matt Pru',
    role       :'Co-founder and Managing Partner',
    company    :'Stackmatix',
    testimonial:'Pareto is the best! Currently using Pareto to automate lead generation for my business and it\'s working great. Customer service is great and the diversity of tasks is amazing. I know I can always trust Pareto whenever something pops up and I need extra support.',
    rating     :5,
    labels     :['Advertising', 'Digital Marketing'],
  },
  {
    image      :'/testimonials/lank-pierce.webp',
    name       :'Lank Pierce',
    role       :'Co-founder and General Manager',
    company    :'Grouphugs',
    testimonial:'I\'ve been working with Pareto since just about their start.I was a bit nervous at first due to the price, but their efficiencies and abilities more than make up for it and my bill is always less than I expect! Working with Pareto has helped us to scale our agency before paying a full-time team. If you want a consistent, thoughtful, communicative, and joyful VA experience - you\'ve found it!',
    rating     :5,
    labels     :['Advertising', 'Entertainment'],
  },
  {
    image      :'/testimonials/jennie-silber.webp',
    name       :'Jennie Silber',
    role       :'Founding Community & UX Research Lead',
    company    :'Koodos Lab',
    testimonial:'They are a great team to work with! They communicate clearly and promptly and can be relied on to get the job done.',
    rating     :5,
    labels     :['Media', 'Music'],
  },
  {
    image      :'/testimonials/dominga-shlotfeld.webp',
    name       :'Dominga Shlotfeld',
    role       :'Supply Content Specialist',
    company    :'Wheel the World',
    testimonial:'A pleasure to work with. The Pareto team has been so professional with their work! they learn fast, answer faster, and are always open to feedback and improvement. A pleasure to work with these women!',
    rating     :5,
    labels     :['Travel', 'Tourism'],
  },
  {
    image      :'/testimonials/joanna-gruau.webp',
    name       :'Joanna Gruau',
    role       :'Product Manager',
    company    :'Wheel the World',
    testimonial:'We have been working with Pareto for almost 5 months already, and it has been a joy to work with these group of talented women. They undertake every task with a professionalism that is hard to find nowadays. Reply rate is always wonderful and everything that they do, they always try to excel and give you the best service they can. Super recommended!',
    rating     :5,
    labels     :['Travel', 'Tourism'],
  },
  {
    image      :'/testimonials/savannah-robertson.webp',
    name       :'Savannah Robertson',
    role       :'Co-founder and CEO',
    company    :'Dame Products',
    testimonial:'I\'ve worked with Pareto for over a year now and I 100% recommend their services. We use Pareto for data entry and analytics and have made them an integral part of our team.',
    rating     :5,
    labels     :['Health and Wellness'],
  },
  {
    image      :'/testimonials/lee-fuhr.webp',
    name       :'Lee Fuhr',
    role       :'Founder and CEO',
    company    :'Cozy',
    testimonial:'Flexible, and very respectful of the spend. Great, collaborative process.',
    rating     :5,
    labels     :['Design', 'Marketing'],
  },
  {
    image      :'/testimonials/kylie-naughton.webp',
    name       :'Kylie Naughton',
    role       :'Co-founder and COO',
    company    :'Jefa',
    testimonial:'Pareto has helped our company with many different research projects. They always completed the task in an efficient time, stuck to deadlines and the quality of the work was always high. Our communication with the Pareto team is always wonderful, they are super friendly and go above and beyond to be helpful.',
    rating     :5,
    labels     :['Finance', 'Fintech'],
  },
  {
    image      :'/testimonials/dave-fontenot.webp',
    name       :'Dave Fontenot',
    role       :'Founder',
    company    :'HF0',
    testimonial:'Pareto is a force multiplier for both my companies. They crush it. It`s like having an army you can throw at any challenge. Pareto\'s team do tasks better than if I had done them myself.',
    rating     :5,
    labels     :['Tech'],
  },
]
